<app-uni-page
  [parent]="this"
  pageTitle="References: Add-Ons"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>
<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <div class="qb-list-actions">
      <button
        [disabled]="!this.user.isProductAdmin"
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-plus"
        (click)="addonAdd()"
      >
        <span>Add Add-On</span>
      </button>
      <div class="flex items-center gap-2 ml-4">
        <p-checkbox
          [disabled]="!user.isProductAdmin"
          inputId="allowCombination"
          [(ngModel)]="allowCombination"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onAllowCombinationChange()"
          [binary]="true"
        >
        </p-checkbox>
        <label for="allowCombination">Allow Combination</label>
      </div>
    </div>
    <app-ag-grid
      [gridOptions]="addonGridOptions"
      [rowSelection]="addonRowSelection"
      class="flex-1 min-h-0"
    ></app-ag-grid>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
